import type {RouteRecordRaw} from 'vue-router';

import {adminPageRoutes} from '@/app/admin/router/pages';

export const adminRoutes: Array<RouteRecordRaw> = [
  {
    path: 'admin/',
    name: 'AdminPage',
    redirect: '/admin/roles',
    children: [...adminPageRoutes],
  },
];

adminRoutes.push({
  path: '/admin/:pathMatch(.*)*',
  redirect: adminRoutes[0].path,
});
